export default "__VITE_ASSET__B$RlZHRH__"